// src/components/StatusBadge.jsx
import React from "react";

/*
StatusBadge: mostra o estado (up/down/slow/n-a) com cor e tooltip.
Uso: <StatusBadge status={p.status} responseTime={p.response_time_ms} />
*/
export default function StatusBadge({ status, responseTime }) {
  const s = (status || "unknown").toLowerCase();
  let className = "inline-block px-2 py-1 rounded text-xs font-medium ";
  let label = s.toUpperCase();

  if (s === "up") {
    className += "bg-green-100 text-green-800";
    label = "Online";
  } else if (s === "slow") {
    className += "bg-yellow-100 text-yellow-800";
    label = "Lento";
  } else if (s === "down") {
    className += "bg-red-100 text-red-800";
    label = "Offline";
  } else if (s === "n/a") {
    className += "bg-gray-100 text-gray-700";
    label = "N/A";
  } else {
    className += "bg-gray-50 text-gray-600";
    label = "Desconhecido";
  }

  const tooltip = responseTime ? `${label} — ${responseTime} ms` : label;
  return (
    <span className={className} title={tooltip} aria-label={label}>
      {label}
    </span>
  );
}
